<script lang="ts">

    export let text: string = '';
</script>


<div>
    {text}
</div>


<style>
    div {
        color: var(--analytics-green);
        padding: 2px 4px;
        font-size: 14px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
</style>